/**
 * Created by vsuthar on 8/18/21
 * File: LabelConstants
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */


/**
 * CAUTION: Please make sure put LABEL as prefix when you put the constnats for Label
 * LABELS goes here
 */
export const LABEL_TENANTS = 'TENANTS'
export const LABEL_SUBSCRIPTIONS_AND_TENANTS = 'Common Services'
export const LABEL_COMMON_SERVICES_SUB_TITLE = 'Manage your existing subscriptions and add-ons, add tenants, and set up identities and roles.'
export const LABEL_ALL_TENANTS = 'ALL TENANTS'
export const LABEL_SUB_TENANTS = 'SUB TENANTS'
export const LABEL_COMMON_SERVICES = 'COMMON SERVICES'
export const LABEL_SWITCH_TENANTS = 'SWITCH TENANTS'
export const LABEL_PRODUCT_SERVICES = 'LICENSED PRODUCTS'
export const LABEL_AGGREGATE_SERVICES = 'AGGREGATE VIEWS'
export const LABEL_LICENSES = 'Licenses'
export const LABEL_LICENSES_PRODUCT = 'Licensed Products'
export const LABEL_LICENSES_SUBTENANT = 'Products Licensed to Subtenants'
export const LABEL_ADD_NEW_TENANT = 'New Tenant'
export const LABEL_ADD_NEW_TENANT_TEMPLATE = 'New Tenant ({0})'
export const LABEL_ADD_NEW_ROOT = 'New Tenant (All Tenants)'
export const LABEL_SUMMARY_NO_LICENSE_FOR_NODE = 'Summary for {0}'
export const LABEL_SUMMARY_NO_LICENSE_SUB_TITLE = '{0} does not yet have any licensed products'
export const LABEL_ADD_SUB_TENANT = 'Add Subtenant'
export const LABEL_EDIT_TENANT = 'Edit Tenant'
export const LABEL_DELETE_TENANT = 'Delete Tenant'
export const LABEL_NOT_APPLICABLE = 'N/A'


/**
 * CAUTION: Please make sure put BUTTON as prefix when you put constnats specific to button
 * Buttons goes here
 */
export const BUTTON_ADD_TENANT = 'Add Tenant'
export const BUTTON_EDIT_TENANT = 'Edit Tenant'
export const BUTTON_SAVE = 'Save'
export const BUTTON_DELETE_TENANT = 'Delete Tenant'
export const BUTTON_LEARN_MORE = 'Learn More'
export const BUTTON_ADD_LICENSE_PRODUCT = 'Add Licensed Product'
export const BUTTON_ADD_SUB_TENANT = 'Add Sub Tenant'
export const BUTTON_CONFIRM_YES_DELETE_TENANT = 'Yes, Delete this Tenant'
export const BUTTON_COPY = 'Copy'
export const BUTTON_CLOSE = 'Close'
export const BUTTON_COPY_ERROR = 'Copy Error Data'
export const BUTTON_GENERATE_OTP = 'Generate OTP'

export const ACTIVATE_SDWAN = 'Activate SD-WAN against parent tenant'
export const SDWAN_ALLOCATION = 'Add your SD-WAN products to this tenant.'


/**
 *CAUTION: Tenant Page related label constants should go hear
 */
export const TENANCY_NOT_SETUP_TENANT = 'You haven\'t set up any tenants yet'
export const TENANCY_NO_DATA_HELPER = ''
export const TENANCY_NO_DATA_DESCRIPTION = ''
export const TENANCY_LICENSE_NO_LICENSE_PRODUCT = 'This tenant doesn\'t have any licensed products yet'
export const TENANCY_TENANT_NAME_PLACEHOLDER = 'Only letters or numbers, up to 255 characters'
export const TENANCY_TENANT_VERTICAL_PLACEHOLDER = 'Business Vertical'
export const SUPPORT_CONTACT_PLACEHOLDER = 'Only letters or numbers, up to 255 characters'
export const TITLE_DELETE_TENANT = 'Delete this tenant?'
export const TITLE_CREATE_TENANT = 'Create New Tenant ({0})'
export const TITLE_EDIT_TENANT = 'Edit Tenant ({0})'

export const PARAGRAPH_DELETE_TENANT = 'If you delete {0}, it will no longer be available as a tenant for any security products, and its licenses will be returned to the pool for {1}.'
export const PARAGRAPH_DELETE_TENANT_CANNOT_UNDONE = 'Deleting a tenant cannot be undone.'
export const PARAGRAPH_DELETE_CONTINUE_PROMPT = 'Are you sure you want to continue?'

export const LABEL_CANNOT_DELETE_TSG_ACCESS = 'You do not have access to delete this tenant.'
export const LABEL_CANNOT_DELETE_TSG_PRODUCTS = 'This tenant still has licensed products assigned to it: {0}. Please contact customer support to remove these products.'
export const LABEL_CANNOT_DELETE_TSG_CLAIMS = 'This tenant still has existing claims. Please remove them through the "Subscription and Addon" tab.'
export const LABEL_CANNOT_DELETE_TSG_CHILDREN = 'This tenant still has child tenants, please delete them first.'

export const PREFIX_SERIAL_NUM = 'Serial Number: '
export const PREFIX_INSTANCE_ID = 'Instance Id: '
export const PREFIX_CSP_TENANT_ID = 'CSP Tenant Id: '
export const PREFIX_SUPPORT_ID = 'Support Account Id: '

export const LABEL_PRODUCT_INFO = 'Product Information'
export const LINK_SUPPORT_CASE = 'support case'
export const ERROR_RESOLUTION_SUBTEXT = 'If you\'ve filed a support case for this product, please copy and attach it to the {0} to facilitate resolution.'

export const PANORAMA_OTP_MODAL_TITLE = 'COPY ONE-TIME PASSWORD'
/**
 * ALL FORM ITEMS
 */

export const FORM_FIELD_TENANT_NAME = 'Name'
export const FORM_FIELD_TENANT_VERTICAL = 'Business Vertical'
export const FORM_FIELD_SUPPORT_CONTACT = 'Support Contact (Optional)'
export const FORM_FIELD_TENANT_ERROR_MESSAGE_NAME_REQUIRED = 'Tenant Name is Required'
export const FORM_FIELD_TENANT_INVALID = 'Tenant Name is invalid'
export const FORM_FIELD_TENANT_ERROR_MESSAGE_NAME_255_MORE = 'Tenant Name can not be longer than 255 characters'
export const FORM_FIELD_TENANT_ERROR_NAME_ALREADY_EXIST = 'Tenant Name Already Exist'
export const FORM_FIELD_SUPPORT_CONTACT_ERROR_MESSAGE_NAME_REQUIRED = 'Support Contact is Required'
export const FORM_FIELD_SUPPORT_CONTACT_ERROR_MESSAGE_NAME_255_MORE = 'Support Contact can not be longer than 255 characters'
export const FORM_FIELD_SUPPORT_CONTACT_INVALID = 'Support Contact is invalid'
export const FORM_FIELD_SUPPORT_CONTACT_INHERITANCE = 'Support Contact Inheritance'
export const FORM_FIELD_SUPPORT_CONTACT_FROM_PARENT = 'Inherit from parent tenant'
export const FORM_FIELD_SUPPORT_CONTACT_USE_CUSTOM = 'Use custom'

export const LICENSE_STATUS_LABEL_PROVISIONING = 'Provisioning'
export const LICENSE_STATUS_LABEL_RUNNING = 'Up'
export const LICENSE_STATUS_LABEL_ERROR = 'Error'
export const LICENSE_STATUS_LABEL_EXPIRED = 'Expired'
export const LICENSE_STATUS_LABEL_STOPPED = 'Stopped'
export const LICENSE_STATUS_LABEL_NOT_PROVISIONED = 'Not Provisioned'
export const LICENSE_STATUS_LABEL_WARNING = 'Warning'
export const LICENSE_STATUS_LABEL_INITIALIZING = 'Initializing'
export const LICENSE_STATUS_LABEL_COMPLETE = 'Complete'


export const LICENSE_STATUS_LABEL_COMPLETE_PERCENT = 100
export const LICENSE_STATUS_LABEL_ERROR_PERCENT = 0

/**
 * TOOLTIP
 */

export const TOOLTIP_ADD_TENANT = BUTTON_ADD_TENANT
export const TOOLTIP_EDIT_TENANT = BUTTON_EDIT_TENANT
export const TOOLTIP_DELETE_TENANT = BUTTON_DELETE_TENANT
export const TOOLTIP_VIEW_SUPPORT = 'View Support Info'
export const TOOLTIP_VIEW_CIE_ACTIVATION = 'Enable CIE to spin up a new CIE instance for the tenant'

/**
 * VERTICAL FILED USE
 */
export const FORM_FIELD_TENANT_VERTICALS = [
  'High Tech',
  'Education',
  'Manufacturing',
  'Hospitality',
  'Professional & Legal Services',
  'Wholesale & Retail',
  'Finance',
  'Telecommunications',
  'State & Local Government',
  'Transportation & Logistics',
  'Federal Government',
  'Media & Entertainment',
  'Nonclassifiable Establishments',
  'Healthcare',
  'Utilities & Energy',
  'Insurance',
  'Agriculture',
  'Pharma & Life Sciences',
  'Construction',
  'Aerospace & Defense',
  'Real Estate',
]

export const PLACEHOLDER_VERTICAL = 'Not Applicable'
